// VERA for desktop updates itself. When a new version has downloaded, a button offers to restart into it now;
// otherwise it installs the next time VERA closes.
import { useEffect, useState } from "react";
import { T, Tf } from "../lib/i18n";
import { desktop, type UpdateStatus } from "../lib/desktop";
import { Icon } from "./ui";

export function useUpdate() {
  const [status, setStatus] = useState<UpdateStatus | null>(null);
  useEffect(() => {
    if (!desktop?.update) return;
    let live = true;
    const read = () => desktop!.update!.status().then((s) => { if (live) setStatus(s); }).catch(() => { /* older builds */ });
    void read();
    const t = window.setInterval(read, 60_000);
    return () => { live = false; window.clearInterval(t); };
  }, []);
  return status;
}

export function UpdateButton({ status }: { status: UpdateStatus | null }) {
  const [busy, setBusy] = useState(false);
  if (status?.state !== "ready") return null;
  return (
    <button className="btn primary" disabled={busy} title={Tf("VERA {version} is ready. It also installs by itself the next time you close VERA.", { version: status.version })}
      onClick={() => { setBusy(true); void desktop!.update!.install(); }}>
      <Icon name="check" size={15} /> {busy ? T("Restarting…") : Tf("Restart to update to {version}", { version: status.version })}
    </button>
  );
}
